import * as THREE from 'three';
import { ThreeEvent } from '@react-three/fiber';
import { BaseTool } from '../BaseTool';
import { WallElement } from '../../core/types';

export class SplitToolClass extends BaseTool {
    id = 'SPLIT';
    name = 'Split Element';
    cursor = 'crosshair';

    private gap: number = 0; // Gap size in mm (or meters depending on units)

    constructor(gap: number = 0) {
        super();
        this.gap = gap;
        if (gap > 0) {
            this.id = 'SPLIT_WITH_GAP';
            this.name = 'Split with Gap';
        }
    }

    onPointerDown(event: ThreeEvent<PointerEvent>): void {
        if (!this.context) return;
        if (event.button !== 0) return;

        const hit = this.getWallIntersection(event);
        if (!hit) return;

        const { wall, point } = hit;

        this.splitWall(wall, point);
    }

    onPointerMove() { }
    onPointerUp() { }

    private getWallIntersection(event: ThreeEvent<PointerEvent>) {
        const hit = this.findElementHitAtPoint(event, (el) => el.category === 'Walls');
        if (!hit) return null;
        return { wall: hit.element as WallElement, point: hit.point };
    }



    private splitWall(wall: WallElement, splitPoint: THREE.Vector3) {
        // Create two new walls from the original
        const start = new THREE.Vector3(...wall.geometryData.start);
        const end = new THREE.Vector3(...wall.geometryData.end);

        // Project splitPoint onto the wall line to be sure
        const line = new THREE.Line3(start, end);
        const projectedSplit = new THREE.Vector3();
        line.closestPointToPoint(splitPoint, true, projectedSplit);

        // Calculate offset for gap (half gap in each direction along the wall line)
        // If gap is 0, offset is 0
        let offsetVec = new THREE.Vector3();
        if (this.gap > 0) {
            const direction = new THREE.Vector3().subVectors(end, start).normalize();
            offsetVec = direction.multiplyScalar(this.gap / 2); // Assuming gap is in same units as geometry
        }

        // Split point adjusted for gap
        const split1 = projectedSplit.clone().sub(offsetVec);
        const split2 = projectedSplit.clone().add(offsetVec);

        // Wall 1: Start to Split1
        const wall1 = {
            ...wall,
            id: THREE.MathUtils.generateUUID(),
            geometryData: {
                ...wall.geometryData,
                end: [split1.x, split1.y, split1.z]
            }
        };

        // Wall 2: Split2 to End
        const wall2 = {
            ...wall,
            id: THREE.MathUtils.generateUUID(),
            geometryData: {
                ...wall.geometryData,
                start: [split2.x, split2.y, split2.z]
            }
        };

        // Remove original, add new ones
        this.context!.bimStore.removeElement(wall.id);
        this.context!.bimStore.addElement(wall1);
        this.context!.bimStore.addElement(wall2);

        // Select the new walls? Or keep tool active?
        // BIM keeps tool active.
    }
}
